import { getMeetingUrl } from '../../../utils/environment';
import { getMeetingInvitation } from '../../../utils/meetingInvitation';
import { getOutlookWebHost } from '../../../utils/microsoftAccount';
import type { MeetingFormData } from '../types';
export interface CalendarDialInOptions {
  phoneNumber?: string | null;
  pin?: string | null;
  hasLicenseError?: boolean;
}

export const buildOutlookCalendarUrl = (
  formData: MeetingFormData,
  dialIn?: CalendarDialInOptions,
  microsoftEmail?: string | null,
): string => {
  const { description, fromDate, fromTime, toDate, toTime, room } = formData;
  const password = formData.password ?? '';

  const start = new Date(`${fromDate}T${fromTime}`).toISOString();
  const end = new Date(`${toDate}T${toTime}`).toISOString();

  const invitationText = getMeetingInvitation(room, dialIn, password);

  const params = new URLSearchParams({
    path: '/calendar/action/compose',
    subject: description,
    body: invitationText,
    bodyishtml: 'true',
    location: getMeetingUrl(room, password) || '',
    startdt: start,
    enddt: end,
  });

  const host = getOutlookWebHost(microsoftEmail);
  return `https://${host}/calendar/0/deeplink/compose?${params.toString()}`;
};

export const buildGoogleCalendarUrl = (
  formData: MeetingFormData,
  dialIn?: CalendarDialInOptions,
): string => {
  const { description, fromDate, fromTime, toDate, toTime, room } = formData;
  const password = formData.password ?? '';

  const start = `${new Date(`${fromDate}T${fromTime}`).toISOString().replace(/[-:]/g, '').split('.')[0]}Z`;
  const end = `${new Date(`${toDate}T${toTime}`).toISOString().replace(/[-:]/g, '').split('.')[0]}Z`;

  const base = 'https://calendar.google.com/calendar/render?action=TEMPLATE';
  const invitationText = getMeetingInvitation(room, dialIn, password);

  const params = new URLSearchParams({
    text: description,
    details: invitationText || description,
    dates: `${start}/${end}`,
    location: getMeetingUrl(room, password) || '',
  });

  return `${base}&${params.toString()}`;
};
